/**
 * Action Cable events from Pipelines::BuildChannel that should trigger a build refetch.
 */
export enum BuildChannelEvent {
  Updated = "updated",
  Started = "started",
  Finished = "finished",
  Skipped = "skipped",
  Canceling = "canceling",
  CommitChanged = "commit:changed",
  StepsChanged = "steps:changed",
  AnnotationsChanged = "annotations:changed",
}
